import * as React from "react";
import { Form, CheckboxProps, Label } from "semantic-ui-react";
import { SharedProps, BaseInputState } from "../base-input";
import { InputValidator } from "../input-validator";
import { debounce } from "@neworbit/simpleui-utils";

export interface CheckboxInputProps extends SharedProps<boolean> {
    toggle?: boolean;
}

export class CheckboxInput extends React.Component<CheckboxInputProps, BaseInputState<boolean>> {

    private validator: InputValidator<boolean>;
    private mounted: boolean = false;

    private handleChange: (event: React.SyntheticEvent<HTMLInputElement>, data: CheckboxProps) => Promise<void>;

    constructor(props: SharedProps<boolean>) {
        super(props);

        const initialValue = this.getValueOrDefault(props.value);

        this.state = {
            value: initialValue,
            errors: [],
            dirty: false,
            touched: false
        };

        this.validator = new InputValidator(props.validation, props.validationOptions);
        this.handleChange = this.getHandleChange().bind(this);
    }

    public render() {
        let errors;

        if (this.state.errors) {
            errors = this.state.errors.map((e, i) => <p key={i}>{e}</p>);
        }

        const showErrors = errors.length > 0 && ((this.state.touched && this.state.dirty) || this.props.showErrors);

        return (
            <div className="field-wrapper">
                <Form.Checkbox
                    toggle={this.props.toggle}
                    checked={this.props.value}
                    label={this.props.label}
                    onChange={this.handleChange}
                    readOnly={this.props.readOnly}
                    disabled={this.props.disabled}
                    required={this.props.required}
                />
                {showErrors && <Label basic color="red" pointing>
                    {errors}
                </Label>}
            </div>
        );
    }

    public async componentWillReceiveProps(props: SharedProps<boolean>) {
        const value = this.getValueOrDefault(props.value);
        const errors = await this.validator.validate(props.value);

        if (this.mounted) {
            this.setState({
                value,
                errors,
                dirty: this.state.dirty || value !== this.state.value
            });
        }
    }

    public async componentDidMount() {
        this.mounted = true;
        const errors = await this.validator.validate(this.state.value);
        this.setState({ errors });
        this.emitOnChange(this.state.value, this.state.errors);
    }

    public componentWillUnmount() {
        this.mounted = false;
    }

    private emitOnChange(value: boolean, errors: string[]): void {
        if (this.props.onChange) {
            const valid = errors.length === 0;
            this.props.onChange(value, valid);
        }
    }

    private getValueOrDefault(value: boolean): boolean {
        return (value !== null && value !== undefined) ? value : false;
    }

    private getHandleChange(): (event: React.SyntheticEvent<HTMLInputElement>, data: CheckboxProps) => Promise<void> {

        const validateFunc = async (value: boolean) => {
            const errors = await this.validator.validate(value);
            this.emitOnChange(this.state.value, errors);
            this.setState({ errors });
        };

        const validateDebounced = debounce((value: boolean) => validateFunc(value), 250);

        return (event: React.SyntheticEvent<HTMLInputElement>, { checked }: CheckboxProps) => {

            this.emitOnChange(checked, this.state.errors);

            this.setState({
                value: checked,
                dirty: true,
                touched: true
            });

            return validateDebounced(checked);
        };
    }
}
